/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowALeftIcon16Light } from './ArrowALeftIcon16Light';
import { ArrowALeftIcon16Regular } from './ArrowALeftIcon16Regular';
import { ArrowALeftIcon16Solid } from './ArrowALeftIcon16Solid';
import { ArrowALeftIcon20Light } from './ArrowALeftIcon20Light';
import { ArrowALeftIcon20Regular } from './ArrowALeftIcon20Regular';
import { ArrowALeftIcon20Solid } from './ArrowALeftIcon20Solid';
import { ArrowALeftIcon24Regular } from './ArrowALeftIcon24Regular';
import { ArrowALeftIcon24Solid } from './ArrowALeftIcon24Solid';
import { ArrowALeftIcon32Regular } from './ArrowALeftIcon32Regular';
import { ArrowALeftIcon64Regular } from './ArrowALeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowALeftIcon16Light,
        regular: ArrowALeftIcon16Regular,
        solid: ArrowALeftIcon16Solid,
    },
    20: {
        light: ArrowALeftIcon20Light,
        regular: ArrowALeftIcon20Regular,
        solid: ArrowALeftIcon20Solid,
    },
    24: {
        regular: ArrowALeftIcon24Regular,
        solid: ArrowALeftIcon24Solid,
    },
    32: {
        regular: ArrowALeftIcon32Regular,
    },
    64: {
        regular: ArrowALeftIcon64Regular,
    },
};
export var ArrowALeftIcon = forwardRef('ArrowALeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
